import React from 'react';
import { useIntl } from 'react-intl';
import { SelectedMenuProductList as SelectedMenuProductListType } from 'rangeConfig/@types';
import { useSelected } from 'contexts/selected';
import ProductThumbs from 'selectedMenu/ProductThumbs';
import ProductList from 'selectedMenu/ProductList';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import Box from 'ui/Box';
import { getMenuTitle } from '../utils/utils';
import { useCore } from 'contexts/core';
import { WidgetContext } from 'contexts/widget';
import Title, { HeadingType } from 'ui/Typography/Title';

type Props = {
  content: SelectedMenuProductListType;
};

/**
 * TODO: This component ideally shouldn't exist. All widget specifications in the
 * range config always provide a component property with a functional react component.
 * All EXCEPT selectedMenu, which might instead take a product list config and
 * transform it automatically to a product list here. This makes the widget context
 * not applicable at application start and requires the context wrapper to live here.
 * In the future we should use a hook like withProducts (see mainMenu ProductList definitions)
 * to avoid breaking this convention and enable us to wrap widgets with necessary data.
 * In a perfect world, the selected menu product list and normal product list would also share types.
 */

const SelectedMenuProductList = ({ content }: Props) => {
  const coreApi = useCore();
  const { formatMessage } = useIntl();
  const { noThumbs, selectedGroup } = useSelected();
  const title = getMenuTitle(content.title, content.titleValue, formatMessage, coreApi);
  const additionalItemsText = getMenuTitle(
    content.additionalItemsText,
    undefined,
    formatMessage,
    coreApi
  );

  return (
    <Box mt="md">
      <Title heading={HeadingType.HeadingThree} type={ThemeFontStyleTypeEnum.headingSmall}>
        {title}
      </Title>
      <WidgetContext.Provider
        value={{
          groupId: selectedGroup?.id ?? '',
          widgetId: content.id,
          menuType: 'selected',
          configId: selectedGroup?.id ?? ''
        }}
      >
        {noThumbs(content) ? (
          <ProductList content={content} />
        ) : (
          <ProductThumbs content={content} additionalItemsText={additionalItemsText} />
        )}
      </WidgetContext.Provider>
    </Box>
  );
};

export default SelectedMenuProductList;
